import useModal from '@/@core/components/base-modal/hooks/useModal'
import router from '@/router'
import store from '@/store'
import {
  onBeforeMount,
  reactive,
  ref,
  watch,
  computed,
  getCurrentInstance,
  onMounted,
} from '@vue/composition-api'
import useFlatPickr from '@/utils/hooks/useFlatPickr'
import NoImgaeIcon from '@/assets/images/icons/img.svg'

import { privilegeCodeTemplateModel } from '@/models/privilege/privilege-code-template'

export default function useCodeTemplateModal(props) {
  const vm = getCurrentInstance().proxy
  const {
    fetchDetailCodeTemplate,
    createCodeTemplate,
    editCodeTemplate,
  } = privilegeCodeTemplateModel()

  const { openModal, closeModal } = useModal()

  const {
    validFrom,
    validThrough,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    resolveDateObject,
    resolveDate,
    resolveTime,
  } = useFlatPickr()

  const modalType = reactive({
    choosePrivilege: false,
    selectImgae: false,
    cropperImage: false
  })

  const onSave = obj => {
    vm.$emit('onSave', obj)
  }

  const onSaveImage = obj => {
    vm.$emit('onSaveImage', obj)
  }

  const openChoosePrivilegeModal = () => {
    modalType.choosePrivilege = true
    openModal()
  }

  const closeChoosePrivilegeModal = () => {
    closeModal()
    modalType.choosePrivilege = false
  }

  const openSelectPrivilegeModal = () => {
    if (props.formModal.privilegeSelect.id == 0) return
    modalType.selectImgae = true
    openModal()
  }

  const closeSelectPrivilegeModal = () => {
    closeModal()
    modalType.selectImgae = false
  }

  const openCropImageModal = () => {
    modalType.cropperImage = true
    openModal()
  }

  const closeCropImageModal = () => {
    closeModal()
    modalType.cropperImage = false
  }

  const onCropImage = (image) => {
    vm.$emit("onCropImage", image);
  };

  onBeforeMount(() => {
    // Todo
  })

  watch(
    props.formModal,
    () => {
      vm.$emit('onChange', props.formModal)
    },
    { deep: true },
  )

  return {
    validFrom,
    validThrough,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    resolveDateObject,
    resolveDate,
    resolveTime,

    modalType,
    openChoosePrivilegeModal,
    closeChoosePrivilegeModal,
    openSelectPrivilegeModal,
    closeSelectPrivilegeModal,
    onSave,
    NoImgaeIcon,
    onSaveImage,

    openCropImageModal,
    closeCropImageModal,
    onCropImage
  }
}
